/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Chip,
  Stack,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import key from 'react-key-string';

const SelectAddGroupForm = (props) => {
  const { groups, onChange, itemKey, robotId, readOnly } = props;
  const [newGroup, setNewGroup] = useState('');
  const [error, setError] = useState(null);

  const onChangeGroupInput = (e) => {
    const {
      target: { value },
    } = e;
    setNewGroup(value);
    setError(null);
  };

  const onAddGroupClick = () => {
    if (groups.filter((item) => item.name === newGroup.trim()).length === 0) {
      const value = {
        name: newGroup.trim(),
        key: key.generate(),
        robots: [],
      };
      onChange({ target: { value, name: 'groups-add' } });
      setNewGroup('');
    } else setError('이미 존재하는 그룹 이름입니다.');
  };

  const handleGroupSelect = (value) => {
    onChange({
      target: {
        value: { ...value, robots: [...value.robots, robotId] },
        name: 'groups-select',
      },
    });
  };

  const handleGroupDeSelect = (value) => () => {
    onChange({
      target: {
        value: {
          ...value,
          robots: value.robots.filter((item) => item !== robotId),
        },
        name: 'groups-select',
      },
    });
  };

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        {readOnly ? '그룹' : '그룹 선택 및 추가'}
      </Typography>
      <Grid container sx={{ alignItems: 'center' }} spacing={1}>
        {!readOnly && (
          <>
            <Grid item xs={12} lg={7}>
              <TextField
                name="group-text-input"
                placeholder="그룹 이름을 입력하세요."
                value={newGroup || ''}
                onChange={onChangeGroupInput}
                className="margin-bottom"
                error={!!error}
                helperText={error}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} lg={5}>
              <Button
                color="secondary"
                variant="contained"
                onClick={onAddGroupClick}
                disabled={newGroup.length === 0}
                startIcon={<AddIcon />}
              >
                그룹추가
              </Button>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Stack direction="row" flexWrap="wrap" gap={1}>
            {groups.map((item, index) => (
              <Chip
                name={index}
                key={`${itemKey}_${index}`}
                value={item.id || ''}
                label={item.name}
                color="secondary"
                variant={
                  item.robots.indexOf(robotId) < 0 ? 'outlined' : 'filled'
                }
                onClick={() => handleGroupSelect(item)}
                onDelete={
                  item.robots.indexOf(robotId) > -1
                    ? handleGroupDeSelect(item)
                    : null
                }
              />
            ))}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SelectAddGroupForm;
